import React, { FC } from 'react';
import { Typography as AntdText } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import useNavigation from '../../../hooks/useNavigation';

type LinkProps = {
  url?: string;
  target?: string;
  underline?: boolean;
  strong?: boolean;
  italic?: boolean;
  size?: number;
  style?: React.CSSProperties;
  text?: string;
} & TextProps;

export const Link: FC<LinkProps> = (props) => {
  let newProps = { ...props };
  const { gotoPage } = useNavigation();
  if (props.size) {
    newProps.style = { ...props.style, fontSize: props.size + 'px' };
  }

  newProps.style = { ...newProps.style, cursor: 'pointer', color: '#08979C', display: 'inline' };

  if (props.target === '_blank') {
    newProps.style = { ...newProps.style, textDecoration: 'none' };
    return (
      <a href={props.url} role="button" target="_blank" rel="noreferrer" {...newProps} children={props.text || props.children} />
    );
  }

  return (
    <AntdText
      onClick={() => {
        if (props.url) {
          gotoPage(props.url);
        }
      }}
      {...newProps}
      children={props.text || props.children}
    />
  );
};

export default Link;
